// import $ from "jquery";
import React, { useEffect, useState, useRef } from "react";

function Footer() {
    const currentYear = new Date().getFullYear();
    return (
        <>

            <div className="footer">
                <footer className="container">
                    <div className="d-flex justify-content-between align-items-center">
                        <div className="small text-white">
                            Copyright © {currentYear} Omni-Net Technologies Pvt. Ltd. India, All Rights Reserved.
                        </div>
                    </div>
                </footer>
            </div>
        </>
    );
}

export default Footer;
